"use strict";
// TODO: 待完善
/*
 * 金山文档-统一UA
 * 调整规则记得更新文档 https://365.kdocs.cn/l/ccFIcJeG8pDG
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUa = exports.getOtherUa = exports.getCommonUa = exports.getThirdUa = exports.getKdocsUa = exports.getWpsUa = exports.getMiniUa = exports.getParams = void 0;
// import { getParams } from "../../../core/helper"
var CLIENT_TYPE = {
    iPad: 'iospad',
    pad: 'androidpad',
    ios: 'ios',
    android: 'android',
    mac: 'macos',
    windows: 'windows',
    linux: 'linux',
    other: 'other',
};
var APP_TYPE = {
    kdocs: 'kdocsdrive',
    wps: 'wpsdrive',
    wxMini: 'wxminiprogram',
    qqMini: 'qqminiprogram',
    qqWeb: 'qqweb',
    wxWeb: 'wxweb',
    web: 'browser',
};
// 获取url的参数
var getParams = function (url) {
    if (!url) {
        return {};
    }
    var params = {};
    var parser = document.createElement('a');
    parser.href = url;
    var query = parser.search.substring(1);
    if (query) {
        var vars = query.split('&');
        for (var i = 0; i < vars.length; i++) {
            var _a = vars[i].split('='), key = _a[0], _b = _a[1], val = _b === void 0 ? '' : _b;
            params[key] = decodeURIComponent(val);
        }
    }
    return params;
};
exports.getParams = getParams;
/**
 * 计算小程序相关ua
 */
function getMiniUa(option) {
    var source = (option || {}).source;
    source = source || getDefaultSource();
    var isWxMiniProgramPc = /miniprogramenv\/(windows|mac)/i.test(source);
    var isQQMiniProgramPc = /(windows|mac).*miniprogramhtmlwebview/i.test(source) && !/mobile/i.test(source);
    var miniProgramFlag = /miniProgram/i.test(source) && !isWxMiniProgramPc && !isQQMiniProgramPc;
    var isWxMiniProgram = ((miniProgramFlag && /micromessenger/i.test(source))
        // @ts-ignore
        || (typeof window !== 'undefined' && window.__wxjs_environment === 'miniprogram'));
    var isQQMiniProgram = miniProgramFlag && / QQ/i.test(source);
    var isMiniProgramMb = isWxMiniProgram || isQQMiniProgram || miniProgramFlag;
    var isMiniProgramPc = isWxMiniProgramPc || isQQMiniProgramPc;
    var isMiniProgram = isMiniProgramMb || isMiniProgramPc;
    var miniProgramType = '';
    if (isWxMiniProgram || isWxMiniProgramPc) {
        miniProgramType = APP_TYPE.wxMini;
    }
    else if (isQQMiniProgram || isQQMiniProgramPc) {
        miniProgramType = APP_TYPE.qqMini;
    }
    return {
        miniProgramType: miniProgramType,
        isWxMiniProgramPc: isWxMiniProgramPc,
        isQQMiniProgramPc: isQQMiniProgramPc,
        isMiniProgramPc: isMiniProgramPc,
        isWxMiniProgram: isWxMiniProgram,
        isQQMiniProgram: isQQMiniProgram,
        isMiniProgramMb: isMiniProgramMb,
        isMiniProgram: isMiniProgram,
    };
}
exports.getMiniUa = getMiniUa;
/**
 * 计算WPS客户端相关ua
 */
function getWpsUa(option) {
    var _a = option || {}, source = _a.source, url = _a.url;
    source = source || getDefaultSource();
    var commonUa = getCommonUa(option);
    url = url || getDefaultUrl();
    var _b = (0, exports.getParams)(url), from = _b.from, v = _b.v, type = _b.type, channel = _b.channel;
    var IS_WPS_DRIVER = /Wps\/\d+\.\d+/i.test(source) && from === 'wps_clouddocs_app';
    var wpsCloudDocumentEmbed = from === 'wps-cloud-document-embed';
    var wpsDocumentEmbed = from === 'wps-document-embed' || from === 'wps-cloud-document-embed';
    var WPS = IS_WPS_DRIVER || wpsCloudDocumentEmbed || wpsDocumentEmbed || (v && type && channel) || type === 'wpsoffice' || ['2018info', 'wps_other_oauth'].indexOf(from) > -1;
    var androidWpsFlag = /wpsmoffice[\s/]/i.test(source); // 以空格或者/结尾
    var isWpsPad = androidWpsFlag && (/appIsTablet/i.test(source) || (!/( Mobile )|appIsPhone/i.test(source)));
    // iPad 
    var isWpsIPad = /wpsmofficeiospadnote|wpsios|wpsmofficeiosnote/i.test(source) && /ipad/i.test(source);
    // 平板 
    var isWpsTablet = isWpsPad || isWpsIPad;
    // IOS 
    var isWpsIos = (/wpsios|wpsmofficeiosnote/i.test(source) && !isWpsIPad) || !!(typeof window !== 'undefined' && window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.handleReq);
    // 安卓 
    var isWpsAndroid = androidWpsFlag && !isWpsPad && !isWpsIos;
    // 移动端 
    var isWpsMb = isWpsAndroid || isWpsIos;
    var pcFlag = (typeof window !== 'undefined' && (window.wpsQuery || window.cefQuery)) || from === 'wpsmac' || WPS;
    // mac 
    var isWpsMac = /wpsofficemacapp/i.test(source) || (pcFlag && commonUa.isMac);
    // win 
    var isWpsWin = (/WpsOffice/i.test(source) || pcFlag) && commonUa.isWindow;
    // linux ua内无wps相关标识
    var isWpsLinux = commonUa.isLinux && pcFlag;
    // pc 
    var isWpsPc = isWpsMac || isWpsWin || isWpsLinux || /wpsofficeapp/i.test(source) || pcFlag;
    var isWps = isWpsTablet || isWpsMb || isWpsPc || pcFlag;
    var wpsClientType = '';
    if (isWpsIPad) {
        wpsClientType = CLIENT_TYPE.iPad;
    }
    else if (isWpsPad) {
        wpsClientType = CLIENT_TYPE.pad;
    }
    else if (isWpsIos) {
        wpsClientType = CLIENT_TYPE.ios;
    }
    else if (isWpsAndroid) {
        wpsClientType = CLIENT_TYPE.android;
    }
    else if (isWpsMac) {
        wpsClientType = CLIENT_TYPE.mac;
    }
    else if (isWpsWin) {
        wpsClientType = CLIENT_TYPE.windows;
    }
    else if (isWpsLinux) {
        wpsClientType = CLIENT_TYPE.linux;
    }
    else if (isWps) {
        wpsClientType = CLIENT_TYPE.other;
    }
    if (wpsClientType) {
        wpsClientType += '_' + APP_TYPE.wps;
    }
    return {
        isWpsMac: isWpsMac,
        isWpsWin: isWpsWin,
        isWpsLinux: isWpsLinux,
        isWpsPc: isWpsPc,
        isWps: isWps,
        isWpsIPad: isWpsIPad,
        isWpsPad: isWpsPad,
        isWpsTablet: isWpsTablet,
        isWpsAndroid: isWpsAndroid,
        isWpsIos: isWpsIos,
        isWpsMb: isWpsMb,
        wpsClientType: wpsClientType,
    };
}
exports.getWpsUa = getWpsUa;
/**
 * 计算金山文档客户端相关ua
 * device_model/xxx 字段仅在2.10.x版本后才支持
 */
function getKdocsUa(option) {
    var source = (option || {}).source;
    source = source || getDefaultSource();
    var commonUa = getCommonUa(option);
    var mKdocsFlag = /m-kdocs\/\d+\.\d+/ig.test(source);
    // pad 不存在androidPad时，可能存在androidPhone且isAndroidTablet
    var isKdocsPadClient = mKdocsFlag && (/device_model\/androidPad/ig.test(source) || (commonUa.isAndroidTablet && !/device_model\/androidPhone/ig.test(source)));
    // ipad
    var isKdocsIPadClient = mKdocsFlag && (/device_model\/iPad/ig.test(source) || commonUa.isIpad);
    var isKdocsTabletClient = isKdocsPadClient || isKdocsIPadClient;
    // 安卓 兼容旧版金山文档标识 Yun-Android/x.x
    var isKdocsAndroidClient = (mKdocsFlag && (/device_model\/androidPhone/ig.test(source) || (commonUa.isAndroidPhone && !isKdocsPadClient))) || /Yun-Android\/\d+\.\d+/ig.test(source);
    // IOS 兼容旧版金山文档标识 Yun-iOS/x.x
    var isKdocsIosClient = (mKdocsFlag && (/device_model\/iPhone/ig.test(source) || commonUa.isIphone)) || /Yun-iOS\/\d+\.\d+/ig.test(source);
    var isKdocsMbClient = isKdocsAndroidClient || isKdocsIosClient;
    // pc 兼容旧版金山文档标识 Yun/x.x 
    var isKdocsPcClient = /kdesktop\/\d+\.\d+/ig.test(source) || /Yun\/\d+\.\d+/ig.test(source);
    // mac
    var isKdocsMacClient = isKdocsPcClient && /macintosh|mac os x/i.test(source);
    // win
    var isKdocsWinClient = isKdocsPcClient && /windows nt/i.test(source);
    // linux
    var isKdocsLinuxClient = isKdocsPcClient && /linux/i.test(source);
    var isKdocsClient = isKdocsPcClient || isKdocsTabletClient || isKdocsMbClient;
    var kdocsClientType = '';
    if (isKdocsIPadClient) {
        kdocsClientType = CLIENT_TYPE.iPad;
    }
    else if (isKdocsPadClient) {
        kdocsClientType = CLIENT_TYPE.pad;
    }
    else if (isKdocsIosClient) {
        kdocsClientType = CLIENT_TYPE.ios;
    }
    else if (isKdocsAndroidClient) {
        kdocsClientType = CLIENT_TYPE.android;
    }
    else if (isKdocsMacClient) {
        kdocsClientType = CLIENT_TYPE.mac;
    }
    else if (isKdocsWinClient) {
        kdocsClientType = CLIENT_TYPE.windows;
    }
    else if (isKdocsLinuxClient) {
        kdocsClientType = CLIENT_TYPE.linux;
    }
    else if (isKdocsClient) {
        kdocsClientType = CLIENT_TYPE.other;
    }
    if (kdocsClientType) {
        kdocsClientType += '_' + APP_TYPE.kdocs;
    }
    return {
        kdocsClientType: kdocsClientType,
        isKdocsIosClient: isKdocsIosClient,
        isKdocsAndroidClient: isKdocsAndroidClient,
        isKdocsIPadClient: isKdocsIPadClient,
        isKdocsPadClient: isKdocsPadClient,
        isKdocsTabletClient: isKdocsTabletClient,
        isKdocsMbClient: isKdocsMbClient,
        isKdocsPcClient: isKdocsPcClient,
        isKdocsMacClient: isKdocsMacClient,
        isKdocsWinClient: isKdocsWinClient,
        isKdocsLinuxClient: isKdocsLinuxClient,
        isKdocsClient: isKdocsClient,
    };
}
exports.getKdocsUa = getKdocsUa;
/**
 * 计算三方应用相关ua
 */
function getThirdUa(option) {
    var source = (option || {}).source;
    source = source || getDefaultSource();
    return {
        isQQ: / QQ/i.test(source),
        isWx: /micromessenger/i.test(source),
    };
}
exports.getThirdUa = getThirdUa;
var isMiUi = function () {
    if (typeof navigator !== 'undefined') {
        return navigator.userAgent.includes('MiuiBrowser');
    }
    else {
        return false;
    }
};
/**
 * 计算通用相关ua
 */
function getCommonUa(option) {
    var source = (option || {}).source;
    source = source || getDefaultSource();
    var isIphone = /iphone/i.test(source);
    var isAndroidPhone = /android/i.test(source) && /mobile/i.test(source);
    var isIpad = /ipad/i.test(source);
    /*
     * 从iOS13开始，iPad设备获取的userAgent值中不再包含“iPad”字段了，而变成了“Macintosh”字段
     */
    if (typeof navigator !== 'undefined' && navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) {
        isIpad = true;
    }
    // 安卓pad 部分pad机型ua存在存在问题(ua中并无android or phone标识),此处添加常用android pad 及小米平板识别
    var isAndroidTablet = !/mobile/i.test(source) && (/android/i.test(source) || isMiUi());
    var isTablet = isIpad || isAndroidTablet || /tablet/i.test(source);
    var isMobileOnly = isIphone || isAndroidPhone || (/mobile/i.test(source) && !isTablet);
    var isWindow = /windows nt/i.test(source);
    var isMac = /macintosh|mac os x/i.test(source) && !isTablet && !isMobileOnly;
    var isLinux = /linux/i.test(source) && !isTablet && !isMobileOnly;
    var isPc = isWindow || isMac || isLinux;
    var commonType = CLIENT_TYPE.other;
    if (isIphone) {
        commonType = CLIENT_TYPE.ios;
    }
    else if (isAndroidPhone) {
        commonType = CLIENT_TYPE.android;
    }
    else if (isIpad) {
        commonType = CLIENT_TYPE.iPad;
    }
    else if (isAndroidTablet) {
        commonType = CLIENT_TYPE.pad;
    }
    else if (isWindow) {
        commonType = CLIENT_TYPE.windows;
    }
    else if (isMac) {
        commonType = CLIENT_TYPE.mac;
    }
    else if (isLinux) {
        commonType = CLIENT_TYPE.linux;
    }
    return {
        commonType: commonType,
        isIphone: isIphone,
        isAndroidPhone: isAndroidPhone,
        isMobileOnly: isMobileOnly,
        isTablet: isTablet,
        isAndroidTablet: isAndroidTablet,
        isIpad: isIpad,
        isWindow: isWindow,
        isMac: isMac,
        isLinux: isLinux,
        isPc: isPc,
    };
}
exports.getCommonUa = getCommonUa;
/**
 * 获取其他Ua
 */
function getOtherUa() {
    var agent = window.navigator.userAgent.toLowerCase();
    // wps iOS端
    var isWpsOfficeIOS = /WpsiOS/i.test(agent);
    // 是否是wps安卓端
    var isWpsOfficeAndroid = /WpsMoffice/i.test(agent);
    // 是否在wps2019中，暂时使用wpsQuery方法判断(wps2019也是客户端)
    // 是否金山文档客户端中
    var isMobileWpsClient = /m-kdocs/i.test(agent);
    var isWpsClient = / yun/i.test(agent) || isMobileWpsClient;
    // @ts-ignore
    var isWps2019 = !isWpsClient && !!window.wpsQuery;
    var isMacOs = agent.indexOf('mac') !== -1;
    // 是否是小米mix折叠屏
    var isMixFold = /M2011J18C\s*Build/i.test(agent);
    // 是否是华为折叠屏Mate X2
    var isHuaweiMateX2 = /TET-AN00/i.test(agent);
    // TODO: 下一版通过screenWidth和scrrenHeight结合android判断，折叠屏的判断就可以去掉
    // 安卓pad 部分pad机型存在问题是因为本身机型是作为手机系统开发的（荣耀7pad 会有mobile标记）
    var isAndroidPad = /(^(?=.*Android)((?!.*mobile)|(?=.*\bpad\b)))|AndroidPad/i.test(agent) && !isMixFold && !isHuaweiMateX2;
    // ios平板(包含ios平板上切桌面模式: navigator的platform和maxTouchPoints的判断是iPad切换的模式)
    var isIPad = /iPad/i.test(agent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    // 平板电脑（可能会连接外接键盘鼠标）
    var isPad = /HUAWEICMR/i.test(agent) || isAndroidPad || isIPad;
    var isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(agent) && !isPad;
    var isInWxMiniProgram = isMobile && /MicroMessenger\/.+ miniProgram/gi.test(agent);
    // 新版本金山文档客户端
    var isKdestop = /kdesktop/i.test(agent);
    var isPcKdocsClient = / yun/i.test(agent) || isKdestop;
    var isIos = /iPhone|iPod|iPad/i.test(agent);
    var isInQQMiniProgram = isMobile && /QQ\/.+ miniProgram/gi.test(agent);
    // 金山文档weboffice组件预览页
    var isKdocs = Boolean(window.__WPSENV__);
    return {
        isWpsOfficeIOS: isWpsOfficeIOS,
        isWpsOfficeAndroid: isWpsOfficeAndroid,
        isWps2019: isWps2019,
        isMacOs: isMacOs,
        isPad: isPad,
        isInWxMiniProgram: isInWxMiniProgram,
        isPcKdocsClient: isPcKdocsClient,
        isMobileWpsClient: isMobileWpsClient,
        isIos: isIos,
        isInQQMiniProgram: isInQQMiniProgram,
        isMobile: isMobile,
        isKdocs: isKdocs
    };
}
exports.getOtherUa = getOtherUa;
/**
 * 获取ua
 */
function getUa(option) {
    var commonUa = getCommonUa(option);
    var thirdUa = getThirdUa(option);
    var miniProgramUa = getMiniUa(option);
    var kdocsClientUa = getKdocsUa(option);
    var wpsClientUa = getWpsUa(option);
    var otherUa = getOtherUa();
    var isQQInnerBrowser = thirdUa.isQQ && !miniProgramUa.isMiniProgram;
    var isWxBrowser = thirdUa.isWx && !miniProgramUa.isMiniProgram;
    var isWeb = false;
    var clientType = wpsClientUa.wpsClientType;
    if (!clientType) {
        if (miniProgramUa.miniProgramType) {
            clientType = commonUa.commonType + '_' + miniProgramUa.miniProgramType;
        }
        else if (isQQInnerBrowser) {
            clientType = commonUa.commonType + '_' + APP_TYPE.qqWeb;
        }
        else if (isWxBrowser) {
            clientType = commonUa.commonType + '_' + APP_TYPE.wxWeb;
        }
        else {
            isWeb = true;
            clientType = commonUa.commonType + '_' + APP_TYPE.web;
        }
    }
    var obj = __assign(__assign(__assign(__assign(__assign(__assign(__assign({}, miniProgramUa), wpsClientUa), thirdUa), kdocsClientUa), commonUa), otherUa), { isWxBrowser: isWxBrowser, isQQInnerBrowser: isQQInnerBrowser, isWeb: isWeb, isMobileWeb: commonUa.isMobileOnly && isWeb, isPcWeb: commonUa.isPc && isWeb, isTabletWeb: commonUa.isTablet && isWeb });
    var keys = Object.keys(obj);
    keys.forEach(function (key) {
        // @ts-ignore
        if (!obj[key]) {
            // @ts-ignore
            delete obj[key];
        }
    });
    return obj;
}
exports.getUa = getUa;
function getDefaultSource() {
    return (typeof navigator !== 'undefined' && navigator.userAgent) || '';
}
function getDefaultUrl() {
    return (typeof location !== 'undefined' && location.href) || '';
}
exports.default = getUa();
